/**
 * GCLID Capture für Luxurywoods.de — v3
 *
 * Änderung gegenüber v2:
 * Schreibt den GCLID nicht nur beim Seitenload in den Cart,
 * sondern auch beim Klick auf jeden Checkout-Button.
 * So landet der GCLID auch im neuen Shopify Extensible Checkout.
 */
(function() {
  'use strict';

  function getParam(name) {
    var match = window.location.search.match(
      new RegExp('[?&]' + name + '=([^&]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() +
      ';path=/;SameSite=Lax;Secure';
  }

  function getCookie(name) {
    var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return v ? decodeURIComponent(v.pop()) : null;
  }

  // 1. Neue Click-IDs aus URL in Cookie speichern (90 Tage)
  var freshGclid  = getParam('gclid');
  var freshGbraid = getParam('gbraid');
  var freshWbraid = getParam('wbraid');

  if (freshGclid)  setCookie('lxry_gclid',  freshGclid,  90);
  if (freshGbraid) setCookie('lxry_gbraid', freshGbraid, 90);
  if (freshWbraid) setCookie('lxry_wbraid', freshWbraid, 90);

  if (freshGclid || freshGbraid || freshWbraid) {
    setCookie('lxry_click_ts',     new Date().toISOString(), 90);
    setCookie('lxry_landing_page', window.location.pathname,  90);
  }

  // 2. Gespeicherte Click-IDs aus Cookie lesen
  function buildAttributes() {
    var storedGclid  = getCookie('lxry_gclid');
    var storedGbraid = getCookie('lxry_gbraid');
    var storedWbraid = getCookie('lxry_wbraid');
    var storedTs     = getCookie('lxry_click_ts');
    var storedLp     = getCookie('lxry_landing_page');

    if (!storedGclid && !storedGbraid && !storedWbraid) return null;

    var attributes = {};
    if (storedGclid)  attributes['gclid']             = storedGclid;
    if (storedGbraid) attributes['gbraid']            = storedGbraid;
    if (storedWbraid) attributes['wbraid']            = storedWbraid;
    if (storedTs)     attributes['gclid_click_ts']    = storedTs;
    if (storedLp)     attributes['gclid_landing_page'] = storedLp;
    return attributes;
  }

  // 3. Funktion: GCLID in Cart schreiben
  function writeToCart(attributes) {
    if (!attributes) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function(err) {
      if (window.console && console.warn) {
        console.warn('[lxry-gclid] Cart update failed:', err);
      }
    });
  }

  // 4. Beim Seitenload in Cart schreiben
  writeToCart(buildAttributes());

  // 5. Beim Klick auf Checkout-Button nochmal schreiben
  // Fängt alle Checkout-Links und -Buttons ab:
  // - /checkout Links
  // - Buttons mit name="checkout"
  // - Shopify Buy-Now Buttons
  document.addEventListener('click', function(e) {
    var el = e.target;

    // Bis zu 5 Elternebenen hochgehen (für verschachtelte Buttons)
    for (var i = 0; i < 5; i++) {
      if (!el) break;

      var isCheckoutLink = el.tagName === 'A' &&
        el.href && el.href.indexOf('/checkout') !== -1;

      var isCheckoutButton = el.tagName === 'BUTTON' &&
        (el.name === 'checkout' ||
         el.getAttribute('data-action') === 'checkout' ||
         (el.className && el.className.indexOf('checkout') !== -1));

      var isCheckoutForm = el.tagName === 'INPUT' &&
        el.type === 'submit' && el.name === 'checkout';

      if (isCheckoutLink || isCheckoutButton || isCheckoutForm) {
        writeToCart(buildAttributes());
        break;
      }
      el = el.parentElement;
    }
  }, true); // capture phase = vor Shopify-Handlers

  // 6. Zusätzlich: Checkout-Form Submit abfangen
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart') !== -1) {
      writeToCart(buildAttributes());
    }
  }, true);

})();